<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router'

defineProps<{
  tabs: { name: string; title: string }[]
}>()

const route = useRoute()
</script>

<template>
  <nav
    class="flex justify-around px-2 py-2 shadow-sm text-[13px] font-medium text-gray-400 border-b border-gray-100 relative bg-gradient-to-r from-[#EFF6FF] via-[#FDF2FF] to-[#FFF1F2] min-h-[52px] items-stretch"
  >
    <RouterLink
      v-for="tab in tabs"
      :key="tab.name"
      :to="{ name: tab.name.toLowerCase() }"
      :class="[
        'px-2 relative transition-all duration-300 h-full flex flex-col items-center justify-center min-w-[70px] min-h-[44px]',
        route.name === tab.name.toLowerCase() ? 'text-[#2B6DFF] font-black' : 'text-gray-400',
      ]"
    >
      <span class="px-1 py-1 text-center break-words whitespace-normal leading-tight max-w-full">{{ $t(tab.title) }}</span>
      <div
        v-if="route.name === tab.name.toLowerCase()"
        class="absolute bottom-[-9px] left-0 right-0 h-[2.5px] bg-[#2B6DFF] rounded-full shadow-[0_1px_4px_rgba(43,109,255,0.3)]"
      ></div>
    </RouterLink>
  </nav>
</template>
